import React, { useRef, useState } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import ChatModal from '../components/ChatModal';
import iconTema from '../assets/icon-Tema.png'
import BackHero from '../assets/BackHeroImoveis.jpg'

const ImovelPage = () => {
  const chatModalRef = useRef(null);

  const handleOpenChat = () => {
    if (chatModalRef.current) {
      chatModalRef.current.openModal();
    }
  };
  // Estado e cálculos do simulador
  const [credito, setCredito] = useState(300000);
  const entradaPercentual = 0.084; // 8.4%
  const parcelaPercentual = 0.0073; // 0.73%
  const entrada = credito * entradaPercentual;
  const parcela = credito * parcelaPercentual;
  return (
    <div>
      <Header onOpenChat={handleOpenChat} />

      {/* Hero Section */}
      <section className="relative gradient-bg text-white section-padding pt-32 overflow-hidden">
        {/* Background Image */}
        <div className="absolute inset-0 opacity-70">
          <img
            src={BackHero}
            alt="Modern Home"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-somax-green/80 via-green-700/70 to-somax-dark/90"></div>
        </div>

        {/* Floating Elements */}
        <div className="absolute top-20 right-20 w-24 h-24 border-2 border-somax-yellow/30 rounded-lg rotate-12 floating-animation"></div>
        <div className="absolute bottom-32 left-10 w-16 h-16 bg-somax-yellow/20 rounded-full floating-animation" style={{ animationDelay: '1s' }}></div>
        <div className="absolute top-40 left-1/3 w-8 h-8 bg-white/30 rounded-lg rotate-45 floating-animation" style={{ animationDelay: '2s' }}></div>

        <div className="container-custom relative z-10">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <div className="inline-block p-3 bg-somax-yellow/20 rounded-2xl mb-6 backdrop-blur-sm">
                <img
                  src={iconTema}
                  alt="Digital Innovation"
                  className="w-16 h-16 mx-auto rounded-lg"
                />
              </div>
              <h1 className="text-4xl md:text-5xl font-bold mb-6 text-shadow-lg glow-text">
                Pare de pagar aluguel e realize o sonho da <span className="text-somax-yellow bg-gradient-to-r from-somax-yellow to-yellow-300 bg-clip-text text-transparent">CASA PRÓPRIA</span>
              </h1>
              <p className="text-xl mb-8 text-green-100 leading-relaxed">
                Com o consórcio imobiliário Somax, você investe no seu futuro e constrói patrimônio
                para toda a família. <span className="font-semibold text-somax-yellow">Sua casa própria está mais perto do que imagina!</span>
              </p>
              <div className="flex flex-col sm:flex-row gap-4">
                <button
                  onClick={handleOpenChat}
                  className="btn-secondary text-lg px-8 py-4 bg-gradient-to-r from-somax-yellow to-yellow-500 hover:from-yellow-500 hover:to-somax-yellow transform hover:scale-105 transition-all duration-300 shadow-2xl hover:shadow-somax-yellow/25"
                >
                  <span className="flex items-center gap-2">
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
                    </svg>
                    Quero Minha Casa Própria!
                  </span>
                </button>
                <div className="text-somax-yellow font-bold text-lg flex items-center bg-white/10 px-4 py-2 rounded-lg backdrop-blur-sm border border-somax-yellow/30">
                  <span className="animate-pulse mr-2">🏠</span> Apartamentos e casas disponíveis
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Authority Section */}
      <section className="section-padding bg-somax-dark text-white">
        <div className="container-custom">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold mb-4">
              <span className="text-somax-yellow">Líderes</span> em Consórcio Imobiliário
            </h2>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto">
              Mais de 15 anos realizando o sonho da casa própria para milhares de famílias
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-4 gap-8 text-center">
            <div>
              <div className="text-4xl font-bold text-somax-green mb-2">8.500+</div>
              <p className="text-gray-300">Famílias contempladas</p>
            </div>
            <div>
              <div className="text-4xl font-bold text-somax-yellow mb-2">98%</div>
              <p className="text-gray-300">Satisfação dos clientes</p>
            </div>
            <div>
              <div className="text-4xl font-bold text-somax-green mb-2">R$ 2B</div>
              <p className="text-gray-300">Em créditos liberados</p>
            </div>
            <div>
              <div className="text-4xl font-bold text-somax-yellow mb-2">15</div>
              <p className="text-gray-300">Anos de experiência</p>
            </div>
          </div>
        </div>
      </section>

      {/* Pain Points Section */}
      <section className="relative section-padding bg-gradient-to-br from-red-900/20 via-red-800/10 to-red-700/20 overflow-hidden">
        {/* Background Image */}
        <div className="absolute inset-0 opacity-10">
          <img
            src="https://images.unsplash.com/photo-1560518883-ce09059eeffa?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2073&q=80"
            alt="Housing Problems"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-red-900/60 via-red-800/40 to-red-700/60"></div>
        </div>

        {/* Floating Elements */}
        <div className="absolute top-10 right-10 w-20 h-20 border-2 border-red-400/30 rounded-full floating-animation"></div>
        <div className="absolute bottom-20 left-20 w-12 h-12 bg-red-500/20 rounded-lg rotate-45 floating-animation" style={{ animationDelay: '1.5s' }}></div>
        <div className="absolute top-1/2 right-1/4 w-6 h-6 bg-red-300/40 rounded-full floating-animation" style={{ animationDelay: '0.5s' }}></div>

        <div className="container-custom relative z-10">
          <div className="text-center mb-12">
            <div className="inline-block p-3 bg-red-500/20 rounded-2xl mb-6 backdrop-blur-sm">
              <svg className="w-12 h-12 text-red-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z" />
              </svg>
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-red-400 mb-4 text-shadow-lg glow-text">
              Cansado de jogar dinheiro fora todo mês?
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            <div className="bg-white/10 backdrop-blur-sm p-6 rounded-2xl shadow-2xl border border-red-400/30 card-hover transform hover:scale-105 transition-all duration-300">
              <div className="text-4xl mb-4">💸</div>
              <h3 className="text-xl font-bold text-red-400 mb-2">Aluguel Eterno</h3>
              <p className="text-red-400 leading-relaxed">Pagando aluguel há anos sem construir patrimônio, dinheiro jogado fora...</p>
              <div className="mt-4 w-full bg-red-900/30 rounded-full h-2">
                <div className="bg-gradient-to-r from-red-500 to-red-400 h-2 rounded-full w-3/4 animate-pulse"></div>
              </div>
            </div>

            <div className="bg-white/10 backdrop-blur-sm p-6 rounded-2xl shadow-2xl border border-red-400/30 card-hover transform hover:scale-105 transition-all duration-300">
              <div className="text-4xl mb-4">📈</div>
              <h3 className="text-xl font-bold text-red-400 mb-2">Preços Subindo</h3>
              <p className="text-red-400 leading-relaxed">Imóveis ficando mais caros, aluguel aumentando, sonho se distanciando...</p>
              <div className="mt-4 w-full bg-red-900/30 rounded-full h-2">
                <div className="bg-gradient-to-r from-red-500 to-red-400 h-2 rounded-full w-4/5 animate-pulse" style={{ animationDelay: '0.5s' }}></div>
              </div>
            </div>

            <div className="bg-white/10 backdrop-blur-sm p-6 rounded-2xl shadow-2xl border border-red-400/30 card-hover transform hover:scale-105 transition-all duration-300">
              <div className="text-4xl mb-4">😰</div>
              <h3 className="text-xl font-bold text-red-400 mb-2">Insegurança</h3>
              <p className="text-red-400 leading-relaxed">Medo de despejo, sem estabilidade, sem lugar para chamar de seu...</p>
              <div className="mt-4 w-full bg-red-900/30 rounded-full h-2">
                <div className="bg-gradient-to-r from-red-500 to-red-400 h-2 rounded-full w-2/3 animate-pulse" style={{ animationDelay: '1s' }}></div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Solution Section */}
      <section className="section-padding bg-somax-light">
        <div className="container-custom">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-somax-dark mb-4">
              A solução para ter sua <span className="text-gradient">CASA PRÓPRIA</span>
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Transforme o valor do aluguel em investimento no seu futuro
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <div className="space-y-6">
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-somax-green rounded-full flex items-center justify-center flex-shrink-0">
                    <span className="text-white font-bold">1</span>
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-somax-dark mb-2">Parcelas Menores</h3>
                    <p className="text-gray-600">Pague menos que um aluguel e construa seu patrimônio.</p>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-somax-yellow rounded-full flex items-center justify-center flex-shrink-0">
                    <span className="text-somax-dark font-bold">2</span>
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-somax-dark mb-2">Sem Burocracia</h3>
                    <p className="text-gray-600">Aprovação rápida, sem complicações bancárias.</p>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-somax-gray rounded-full flex items-center justify-center flex-shrink-0">
                    <span className="text-white font-bold">3</span>
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-somax-dark mb-2">Valorização Garantida</h3>
                    <p className="text-gray-600">Imóvel próprio valoriza com o tempo, é investimento certo.</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Simulador de Carta de Crédito */}
            <div className="bg-white p-8 rounded-lg shadow-xl border border-somax-yellow/30">
              <div>
                <h2 className="text-3xl font-bold text-center text-somax-dark mb-6">
                  <span className="text-somax-yellow">Simulador</span> de Carta de Crédito
                </h2>

                {/* Slider */}
                <div className="mb-6">
                  <label className="block text-lg font-medium mb-2 text-somax-dark">Valor do Imóvel:</label>
                  <input
                    type="range"
                    min="100000"
                    max="2000000"
                    step="10000"
                    value={credito}
                    onChange={(e) => setCredito(Number(e.target.value))}
                    className="w-full accent-somax-yellow"
                  />
                  <div className="text-center text-xl font-semibold text-somax-dark mt-2">
                    R$ {credito.toLocaleString('pt-BR')}
                  </div>
                </div>

                {/* Resultados */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-8">
                  <div className="bg-somax-light p-5 rounded-lg border border-somax-yellow/30">
                    <h3 className="text-lg font-bold text-somax-dark mb-2">Entrada Aproximada</h3>
                    <p className="text-2xl font-semibold text-somax-yellow">
                      R$ {entrada.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
                    </p>
                  </div>

                  <div className="bg-somax-light p-5 rounded-lg border border-somax-yellow/30">
                    <h3 className="text-lg font-bold text-somax-dark mb-2">Parcelas Mensais</h3>
                    <p className="text-2xl font-semibold text-somax-yellow">
                      R$ {parcela.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
                    </p>
                  </div>
                </div>

                <div className="text-center mt-8">
                  <button
                    onClick={handleOpenChat}
                    className="btn-secondary text-lg px-8 py-3 bg-gradient-to-r from-somax-yellow to-yellow-500 hover:from-yellow-500 hover:to-somax-yellow text-white font-bold rounded-lg shadow-lg transition"
                  >
                    Quero Simular Completo
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* Photo Collage Grid - Bottom Left */}

        </div>
      </section>

      {/* Success Cases Section */}
      <section className="relative section-padding bg-gradient-to-br from-somax-green/10 via-green-50 to-somax-light overflow-hidden">
        {/* Background Image */}
        <div className="absolute inset-0 opacity-5">
          <img
            src="https://images.unsplash.com/photo-1564013799919-ab600027ffc6?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80"
            alt="Happy Families"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-somax-green/20 via-green-100/30 to-somax-light/40"></div>
        </div>

        {/* Floating Elements */}
        <div className="absolute top-16 right-16 w-20 h-20 border-2 border-somax-green/30 rounded-full floating-animation"></div>
        <div className="absolute bottom-24 left-16 w-14 h-14 bg-somax-yellow/20 rounded-lg rotate-12 floating-animation" style={{ animationDelay: '1s' }}></div>
        <div className="absolute top-1/3 right-1/3 w-8 h-8 bg-somax-green/30 rounded-full floating-animation" style={{ animationDelay: '2s' }}></div>

        <div className="container-custom relative z-10">
          <div className="text-center mb-12">
            <div className="inline-block p-3 bg-somax-green/20 rounded-2xl mb-6 backdrop-blur-sm">
              <svg className="w-12 h-12 text-somax-green" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
              </svg>
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-somax-dark mb-4 text-shadow-lg glow-text">
              Famílias que realizaram o <span className="text-somax-green bg-gradient-to-r from-somax-green to-green-400 bg-clip-text text-transparent">SONHO</span>
            </h2>
            <p className="text-xl text-gray-600 leading-relaxed">Histórias reais de quem conquistou a casa própria</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="bg-white/80 backdrop-blur-sm p-8 rounded-2xl shadow-2xl border border-somax-green/20 card-hover transform hover:scale-105 transition-all duration-300">
              <div className="flex items-center mb-6">
                <div className="w-16 h-16 bg-gradient-to-r from-somax-green to-green-400 rounded-full flex items-center justify-center mr-4 shadow-lg">
                  <span className="text-white font-bold text-xl">M</span>
                </div>
                <div>
                  <h4 className="text-xl font-bold text-somax-dark">Maria Santos</h4>
                  <p className="text-gray-600">Professora - Rio de Janeiro</p>
                </div>
              </div>
              <div className="mb-4">
                <div className="text-3xl font-bold text-somax-green mb-2 glow-text">Contemplada</div>
                <p className="text-gray-600">Apartamento 2 quartos - 18º mês</p>
                <div className="mt-2 w-full bg-gray-200 rounded-full h-2">
                  <div className="bg-gradient-to-r from-somax-green to-green-400 h-2 rounded-full w-4/5 animate-pulse"></div>
                </div>
              </div>
              <p className="text-gray-700 italic mb-4 leading-relaxed">
                "Pagava R$ 800 de aluguel. Hoje pago R$ 650 da parcela do MEU apartamento.
                Melhor decisão da minha vida!"
              </p>
              <div className="flex text-somax-yellow text-xl">
                ⭐⭐⭐⭐⭐
              </div>
            </div>

            <div className="bg-white/80 backdrop-blur-sm p-8 rounded-2xl shadow-2xl border border-somax-yellow/20 card-hover transform hover:scale-105 transition-all duration-300">
              <div className="flex items-center mb-6">
                <div className="w-16 h-16 bg-gradient-to-r from-somax-yellow to-yellow-400 rounded-full flex items-center justify-center mr-4 shadow-lg">
                  <span className="text-somax-dark font-bold text-xl">J</span>
                </div>
                <div>
                  <h4 className="text-xl font-bold text-somax-dark">João Oliveira</h4>
                  <p className="text-gray-600">Vendedor - São Paulo</p>
                </div>
              </div>
              <div className="mb-4">
                <div className="text-3xl font-bold text-somax-green mb-2 glow-text">Contemplado</div>
                <p className="text-gray-600">Casa 3 quartos - 24º mês</p>
                <div className="mt-2 w-full bg-gray-200 rounded-full h-2">
                  <div className="bg-gradient-to-r from-somax-yellow to-yellow-400 h-2 rounded-full w-full animate-pulse" style={{ animationDelay: '0.5s' }}></div>
                </div>
              </div>
              <p className="text-gray-700 italic mb-4 leading-relaxed">
                "Minha família toda morava de aluguel. Fui o primeiro a ter casa própria.
                Agora meus filhos têm onde crescer!"
              </p>
              <div className="flex text-somax-yellow text-xl">
                ⭐⭐⭐⭐⭐
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Comparison Section */}
      <section className="relative section-padding bg-somax-dark text-white overflow-hidden">
        {/* Background Image */}
        <div className="absolute inset-0 opacity-10">
          <img
            src="https://images.unsplash.com/photo-1560518883-ce09059eeffa?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2073&q=80"
            alt="Financial Comparison"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-somax-dark/80 via-gray-900/60 to-somax-dark/80"></div>
        </div>

        {/* Floating Elements */}
        <div className="absolute top-20 left-20 w-16 h-16 border-2 border-somax-yellow/30 rounded-full floating-animation"></div>
        <div className="absolute bottom-20 right-20 w-12 h-12 bg-red-500/20 rounded-lg rotate-45 floating-animation" style={{ animationDelay: '1.5s' }}></div>
        <div className="absolute top-1/2 left-1/4 w-6 h-6 bg-somax-green/30 rounded-full floating-animation" style={{ animationDelay: '3s' }}></div>

        <div className="container-custom relative z-10">
          <div className="text-center mb-12">
            <div className="inline-block p-3 bg-somax-yellow/20 rounded-2xl mb-6 backdrop-blur-sm">
              <svg className="w-12 h-12 text-somax-yellow" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
              </svg>
            </div>
            <h2 className="text-3xl md:text-4xl font-bold mb-4 text-shadow-lg glow-text">
              Aluguel vs <span className="text-somax-yellow bg-gradient-to-r from-somax-yellow to-yellow-400 bg-clip-text text-transparent">Consórcio</span>
            </h2>
            <p className="text-xl text-gray-300 leading-relaxed">Veja a diferença em 10 anos</p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            {/* Aluguel */}
            <div className="bg-gradient-to-br from-red-600 to-red-700 p-8 rounded-2xl shadow-2xl border border-red-500/30 card-hover transform hover:scale-105 transition-all duration-300">
              <h3 className="text-2xl font-bold mb-6 text-center text-shadow-lg">💸 Pagando Aluguel</h3>

              <div className="space-y-4">
                <div className="flex justify-between items-center p-4 bg-red-700 rounded-lg">
                  <span>Valor mensal:</span>
                  <span className="font-bold">R$ 800</span>
                </div>
                <div className="flex justify-between items-center p-4 bg-red-700 rounded-lg">
                  <span>Total em 10 anos:</span>
                  <span className="font-bold">R$ 96.000</span>
                </div>
                <div className="flex justify-between items-center p-4 bg-red-800 rounded-lg">
                  <span>Patrimônio construído:</span>
                  <span className="font-bold text-red-300">R$ 0</span>
                </div>
                <div className="text-center text-red-200 mt-4">
                  ❌ Dinheiro jogado fora<br />
                  ❌ Sem patrimônio<br />
                  ❌ Sem segurança
                </div>
              </div>
            </div>

            {/* Consórcio */}
            <div className="bg-gradient-to-br from-somax-green to-green-600 p-8 rounded-2xl shadow-2xl border border-somax-green/30 card-hover transform hover:scale-105 transition-all duration-300">
              <h3 className="text-2xl font-bold mb-6 text-center text-shadow-lg">🏠 Consórcio Somax</h3>

              <div className="space-y-4">
                <div className="flex justify-between items-center p-4 bg-green-700/80 backdrop-blur-sm rounded-lg border border-green-500/30">
                  <span>Valor mensal:</span>
                  <span className="font-bold glow-text">R$ 650</span>
                </div>
                <div className="flex justify-between items-center p-4 bg-green-700/80 backdrop-blur-sm rounded-lg border border-green-500/30">
                  <span>Total em 10 anos:</span>
                  <span className="font-bold glow-text">R$ 78.000</span>
                </div>
                <div className="flex justify-between items-center p-4 bg-green-600/80 backdrop-blur-sm rounded-lg border border-green-400/30">
                  <span>Patrimônio construído:</span>
                  <span className="font-bold text-somax-yellow glow-text">R$ 200.000+</span>
                </div>
                <div className="text-center text-green-100 mt-4 leading-relaxed">
                  ✅ Investimento inteligente<br />
                  ✅ Patrimônio garantido<br />
                  ✅ Segurança total
                </div>
              </div>
            </div>
          </div>

          <div className="text-center mt-8">
            <div className="text-2xl font-bold text-somax-yellow mb-4 text-shadow-lg glow-text">
              Economia de R$ 18.000 + Imóvel de R$ 200.000 = Vantagem de R$ 218.000!
            </div>
            <button
              onClick={handleOpenChat}
              className="btn-secondary transform hover:scale-105 transition-all duration-300 shadow-2xl"
            >
              <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
              </svg>
              Quero Essa Vantagem!
            </button>
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="relative section-padding bg-gradient-to-br from-somax-light via-green-50 to-white overflow-hidden">
        {/* Background Image */}
        <div className="absolute inset-0 opacity-5">
          <img
            src="https://images.unsplash.com/photo-1560472354-b33ff0c44a43?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2126&q=80"
            alt="Digital Innovation"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-somax-light/60 via-green-50/40 to-white/60"></div>
        </div>

        {/* Floating Elements */}
        <div className="absolute top-16 right-16 w-20 h-20 border-2 border-somax-green/30 rounded-full floating-animation"></div>
        <div className="absolute bottom-24 left-16 w-14 h-14 bg-somax-yellow/20 rounded-lg rotate-12 floating-animation" style={{ animationDelay: '1s' }}></div>
        <div className="absolute top-1/3 right-1/3 w-8 h-8 bg-somax-green/30 rounded-full floating-animation" style={{ animationDelay: '2s' }}></div>

        <div className="container-custom relative z-10">
          <div className="text-center mb-12">
            <div className="inline-block p-3 bg-somax-green/20 rounded-2xl mb-6 backdrop-blur-sm">
              <svg className="w-12 h-12 text-somax-green" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z" />
              </svg>
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-somax-dark mb-4 text-shadow-lg glow-text">
              Vantagens <span className="text-somax-green bg-gradient-to-r from-somax-green to-green-400 bg-clip-text text-transparent">EXCLUSIVAS</span>
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            <div className="bg-white/80 backdrop-blur-sm p-6 rounded-2xl shadow-2xl text-center border border-somax-green/20 card-hover transform hover:scale-105 transition-all duration-300">
              <div className="text-4xl mb-4">🏆</div>
              <h3 className="text-xl font-bold text-somax-dark mb-2 glow-text">Sem Análise de Crédito</h3>
              <p className="text-gray-600 leading-relaxed">Nome sujo? Sem problema! Aprovação garantida.</p>
              <div className="mt-4 w-full bg-gray-200 rounded-full h-2">
                <div className="bg-gradient-to-r from-somax-green to-green-400 h-2 rounded-full w-full animate-pulse"></div>
              </div>
            </div>

            <div className="bg-white/80 backdrop-blur-sm p-6 rounded-2xl shadow-2xl text-center border border-somax-yellow/20 card-hover transform hover:scale-105 transition-all duration-300">
              <div className="text-4xl mb-4">💰</div>
              <h3 className="text-xl font-bold text-somax-dark mb-2 glow-text">Sem Entrada</h3>
              <p className="text-gray-600 leading-relaxed">Comece a pagar só quando for contemplado.</p>
              <div className="mt-4 w-full bg-gray-200 rounded-full h-2">
                <div className="bg-gradient-to-r from-somax-yellow to-yellow-400 h-2 rounded-full w-4/5 animate-pulse" style={{ animationDelay: '0.5s' }}></div>
              </div>
            </div>

            <div className="bg-white/80 backdrop-blur-sm p-6 rounded-2xl shadow-2xl text-center border border-somax-green/20 card-hover transform hover:scale-105 transition-all duration-300">
              <div className="text-4xl mb-4">🎯</div>
              <h3 className="text-xl font-bold text-somax-dark mb-2 glow-text">Escolha seu Imóvel</h3>
              <p className="text-gray-600 leading-relaxed">Apartamento, casa, terreno - você decide!</p>
              <div className="mt-4 w-full bg-gray-200 rounded-full h-2">
                <div className="bg-gradient-to-r from-somax-green to-green-400 h-2 rounded-full w-3/4 animate-pulse" style={{ animationDelay: '1s' }}></div>
              </div>
            </div>

            <div className="bg-white/80 backdrop-blur-sm p-6 rounded-2xl shadow-2xl text-center border border-somax-yellow/20 card-hover transform hover:scale-105 transition-all duration-300">
              <div className="text-4xl mb-4">📱</div>
              <h3 className="text-xl font-bold text-somax-dark mb-2 glow-text">App Exclusivo</h3>
              <p className="text-gray-600 leading-relaxed">Acompanhe tudo pelo celular, fácil e prático.</p>
              <div className="mt-4 w-full bg-gray-200 rounded-full h-2">
                <div className="bg-gradient-to-r from-somax-yellow to-yellow-400 h-2 rounded-full w-5/6 animate-pulse" style={{ animationDelay: '1.5s' }}></div>
              </div>
            </div>

            <div className="bg-white/80 backdrop-blur-sm p-6 rounded-2xl shadow-2xl text-center border border-somax-green/20 card-hover transform hover:scale-105 transition-all duration-300">
              <div className="text-4xl mb-4">🔒</div>
              <h3 className="text-xl font-bold text-somax-dark mb-2 glow-text">Seguro Incluso</h3>
              <p className="text-gray-600 leading-relaxed">Proteção total para você e sua família.</p>
              <div className="mt-4 w-full bg-gray-200 rounded-full h-2">
                <div className="bg-gradient-to-r from-somax-green to-green-400 h-2 rounded-full w-full animate-pulse" style={{ animationDelay: '2s' }}></div>
              </div>
            </div>

            <div className="bg-white/80 backdrop-blur-sm p-6 rounded-2xl shadow-2xl text-center border border-somax-yellow/20 card-hover transform hover:scale-105 transition-all duration-300">
              <div className="text-4xl mb-4">⚡</div>
              <h3 className="text-xl font-bold text-somax-dark mb-2 glow-text">Contemplação Rápida</h3>
              <p className="text-gray-600 leading-relaxed">Média de 18 meses para ser contemplado.</p>
              <div className="mt-4 w-full bg-gray-200 rounded-full h-2">
                <div className="bg-gradient-to-r from-somax-yellow to-yellow-400 h-2 rounded-full w-4/5 animate-pulse" style={{ animationDelay: '2.5s' }}></div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Urgency Section */}
      <section className="relative section-padding bg-gradient-to-br from-red-600 to-red-700 text-white overflow-hidden">
        {/* Background Image */}
        <div className="absolute inset-0 opacity-10">
          <img
            src="https://images.unsplash.com/photo-1551288049-bebda4e38f71?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80"
            alt="Urgency Clock"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-red-600/80 via-red-700/60 to-red-600/80"></div>
        </div>

        {/* Floating Elements */}
        <div className="absolute top-16 right-16 w-20 h-20 border-2 border-yellow-400/30 rounded-full floating-animation"></div>
        <div className="absolute bottom-24 left-16 w-14 h-14 bg-yellow-400/20 rounded-lg rotate-12 floating-animation" style={{ animationDelay: '1s' }}></div>
        <div className="absolute top-1/3 right-1/3 w-8 h-8 bg-white/20 rounded-full floating-animation" style={{ animationDelay: '2s' }}></div>

        <div className="container-custom text-center relative z-10">
          <div className="inline-block p-3 bg-yellow-400/20 rounded-2xl mb-6 backdrop-blur-sm">
            <svg className="w-12 h-12 text-yellow-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
          <h2 className="text-3xl md:text-4xl font-bold mb-4 text-shadow-lg glow-text">
            🚨 OFERTA ESPECIAL: Últimas 5 Vagas do Mês
          </h2>
          <p className="text-xl mb-8 max-w-3xl mx-auto leading-relaxed">
            <strong>Taxa de adesão ZERO</strong> para quem se inscrever hoje.
            Não perca essa chance única de realizar seu sonho!
          </p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
            <div className="bg-white/90 backdrop-blur-sm text-red-600 p-6 rounded-2xl shadow-2xl border border-yellow-400/30 card-hover transform hover:scale-105 transition-all duration-300">
              <div className="text-2xl font-bold mb-2 glow-text">Taxa Zero</div>
              <div className="text-lg">Economia de R$ 500 na adesão</div>
              <div className="mt-3 w-full bg-red-200 rounded-full h-2">
                <div className="bg-gradient-to-r from-red-500 to-red-600 h-2 rounded-full w-full animate-pulse"></div>
              </div>
            </div>
            <div className="bg-white/90 backdrop-blur-sm text-red-600 p-6 rounded-2xl shadow-2xl border border-yellow-400/30 card-hover transform hover:scale-105 transition-all duration-300">
              <div className="text-2xl font-bold mb-2 glow-text">Brinde Especial</div>
              <div className="text-lg">Kit casa nova de R$ 300</div>
              <div className="mt-3 w-full bg-red-200 rounded-full h-2">
                <div className="bg-gradient-to-r from-yellow-400 to-yellow-500 h-2 rounded-full w-4/5 animate-pulse" style={{ animationDelay: '0.5s' }}></div>
              </div>
            </div>
            <div className="bg-white/90 backdrop-blur-sm text-red-600 p-6 rounded-2xl shadow-2xl border border-yellow-400/30 card-hover transform hover:scale-105 transition-all duration-300">
              <div className="text-2xl font-bold mb-2 glow-text">Consultoria VIP</div>
              <div className="text-lg">Acompanhamento personalizado</div>
              <div className="mt-3 w-full bg-red-200 rounded-full h-2">
                <div className="bg-gradient-to-r from-yellow-400 to-yellow-500 h-2 rounded-full w-3/4 animate-pulse" style={{ animationDelay: '1s' }}></div>
              </div>
            </div>
          </div>

          <div className="text-2xl font-bold mb-4">
            ⏰ Oferta válida apenas hoje!
          </div>

          <button
            onClick={handleOpenChat}
            className="bg-somax-yellow hover:bg-yellow-500 text-somax-dark font-bold py-4 px-8 rounded-lg transition-all duration-300 transform hover:scale-105 text-lg"
          >
            <svg className="w-6 h-6 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-3.582 8-8 8a8.955 8.955 0 01-4.126-.98L3 20l1.98-5.874A8.955 8.955 0 013 12c0-4.418 3.582-8 8-8s8 3.582 8 8z" />
            </svg>
            Garantir Minha Casa Própria!
          </button>
        </div>
      </section>
      <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3838.2879952511803!2d-48.046585524868874!3d-15.841453784805537!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x935a328bd8bc60c1%3A0xd082313d70393121!2sTaguatinga%20Shopping!5e0!3m2!1spt-BR!2sbr!4v1760663397520!5m2!1spt-BR!2sbr" width="100%" style={{border:"0",}} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
      <Footer />
      <ChatModal ref={chatModalRef} />
    </div>
  );
};

export default ImovelPage;
